export default "__VITE_ASSET__DuxW9DAj__"